module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_1.78167e7e.png";